import * as React from 'react';
import { Button, ModalWindow, RadioGroup } from '@cian/ui-kit';
import { OPTIONS } from './constants';
import { useIsMobileDevice } from '../../../../hooks';

interface IReasonModal {
  onSubmit: (value: string) => void;
  onClose: (value: string) => void;
  isOpen: boolean;
}

export const DEFAULT_REASON = 'Ничего не выбрано';

export const ReasonModal: React.FC<IReasonModal> = ({ onSubmit, isOpen, onClose }) => {
  const [reason, setReason] = React.useState<string | undefined>();
  const isMobile = useIsMobileDevice();

  return (
    <ModalWindow
      title="Почему вы не указали кадастровый номер участка?"
      open={isOpen}
      onClose={() => onClose(DEFAULT_REASON)}
      fixed={isMobile}
      width={448}
      footer={
        <Button onClick={() => onSubmit(reason!)} fullWidth={isMobile} disabled={!reason} size={isMobile ? 'L' : 'XS'}>
          Отправить
        </Button>
      }
      content={<RadioGroup options={OPTIONS} onChange={(_, value) => setReason(String(value))} />}
    />
  );
};
